module.exports = __webpack_public_path__ + "assets/img/cancel.08e0ef3e.png";